import './ServiceRequestChangeAddress.css';

import InputWidget from '../../../lib/InputWidget/InputWidget';
import SelectWidget from '../../../lib/SelectWidget/SelectWidget';
import {
  pushViewAction,
  getServiceRequestDetailsAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {postAPICall} from '../../../services/apiCallsHandler';
import {
  GERMANY_COUNTRY_CODE,
  PORTUGAL_COUNTRY_CODE,
  SPAIN_COUNTRY_CODE,
  UK_COUNTRY_CODE,
  SUPPORTED_COUNTRY_LIST,
} from '../../../utils/constant';
import {enqueueToastUI, replaceTranslations} from '../../../utils/util';

import {
  Card,
  Box,
  CardContent,
  Button,
  CircularProgress,
  useToastProvider,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import countrySpecificConfig from './ServiceRequestChangeAddressConfig.json';

const ServiceRequestChangeAddress = (props) => {
  const {t} = useTranslation();

  const dropDownItem = [
    {label: t('SPAIN'), value: SPAIN_COUNTRY_CODE},
    {label: t('GERMANY'), value: GERMANY_COUNTRY_CODE},
    {label: t('UNITED_KINGDOM'), value: UK_COUNTRY_CODE},
    {label: t('PORTUGAL'), value: PORTUGAL_COUNTRY_CODE},
  ];

  const [street, setStreet] = React.useState('');
  const [city, setCity] = React.useState('');
  const [addInfo, setAddInfo] = React.useState();
  const [zipcode, setZipcode] = React.useState('');
  const [state, setState] = React.useState('');
  const [house, setHouse] = React.useState('');
  const [selectedCountry, setSelectedCountry] = React.useState(props.country);
  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const country = SUPPORTED_COUNTRY_LIST.includes(props.country)
    ? props.country
    : SPAIN_COUNTRY_CODE;

  const {enqueueToast} = useToastProvider();

  const zipRegEx = {
    es: /\D/g,
    gb: /[^a-zA-Z0-9]/g,
    pt: /\D/g,
  };
  const sortDropdownItems = (items, userCountry) => {
    return items.sort((a, b) => {
      if (a.value === userCountry) return -1;
      if (b.value === userCountry) return 1;
      return a.label.localeCompare(b.label);
    });
  };
  sortDropdownItems(dropDownItem, country);

  const zipCodeChangeHandler = (e) => {
    const regex = zipRegEx[country];
    const cleanedValue = e.replace(regex, '');
    setZipcode(cleanedValue);
  };

  const addressSubmitHandler = (e) => {
    const reqBody = {};
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }
    reqBody.contractNumber = props.contractNumber;
    reqBody.street = street;
    reqBody.city = city;
    reqBody.zipcode = zipcode;
    if (country === SPAIN_COUNTRY_CODE) {
      reqBody.state = state;
      reqBody.addInfo = addInfo;
    }
    if (country === UK_COUNTRY_CODE || country === GERMANY_COUNTRY_CODE) {
      reqBody.house = house;
    }
    reqBody.country = selectedCountry;
    reqBody.requestType = 'Change Address';
    reqBody.countryCode = props.country;
    reqBody.userEmail = props.userDetails.email;
    e.preventDefault();
    setSubmitDisabled(true);
    setLoader(true);
    postAPICall(
      'serviceRequest',
      {...reqBody},
      {
        errorTag: 'CHANGE_ADDRESS_SERVICE_REQUEST',
      }
    ).then((res) => {
      setLoader(false);
      setSubmitDisabled(false);
      if (res.status === 429) {
        enqueueToastUI(
          res.status,
          enqueueToast,
          null,
          replaceTranslations(
            t('SERVICE_REQUEST_LIMIT'),
            50,
            reqBody.requestType
          )
        );
      } else {
        enqueueToastUI(
          res.status,
          enqueueToast,
          t('SERVICE_REQUEST_SUCCESS'),
          t('SERVICE_REQUEST_CREATION_FAILED')
        );
      }
      if (res.status == 200) {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        appStore.dispatch(pushViewAction('serviceRequestDashboard'));
      }
    });
  };

  const addressButtonControls = () => {
    return (
      <div className="buttonControls">
        <Button
          id="cancelButton"
          onClick={() => props.cancelButtonClick(null)}
          variant="secondary"
        >
          {t('CANCEL')}
        </Button>

        <Button
          type="submit"
          disabled={submitDisabled}
          id="primaryBtn"
          variant="primary"
          startIcon={
            loader && <CircularProgress size="small" style={{color: '#000'}} />
          }
        >
          {t('SUBMIT')}
        </Button>
      </div>
    );
  };

  const onAddressStreetChangeHandler = (value) => {
    setStreet(value);
  };
  const onAddressCityChangeHandler = (value) => {
    setCity(value);
  };
  const onAddInfoChangeHandler = (value) => {
    setAddInfo(value);
  };
  const onZipChangeHandler = (value) => {
    if (value.length <= countrySpecificConfig[country]?.zip?.maxLength) {
      zipCodeChangeHandler(value);
    }
  };
  const onStateChangeHandler = (value) => {
    setState(value);
  };
  const onHouseChangeHandler = (value) => {
    setHouse(value);
  };
  const formFields = [
    {
      label: 'CHANGE_ADDRESS_HOUSE_NUMBER',
      type: 'text',
      required: true,
      id: 'change-address-house-number',
      value: house,
      setValue: onHouseChangeHandler,
      error: house.length > 0,
      helperText: 'HOUSE_MANDATORY',
    },
    {
      label: 'CHANGE_ADDRESS_STREET',
      type: 'text',
      required: true,
      id: 'change-address-street',
      value: street,
      setValue: onAddressStreetChangeHandler,
      error: street.length > 0,
      helperText: 'STREET_MANDATORY',
    },
    {
      label: 'CHANGE_ADDRESS_CITY',
      type: 'text',
      required: true,
      id: 'change-address-city',
      value: city,
      setValue: onAddressCityChangeHandler,
      error: city.length > 0,
      helperText: 'CITY_MANDATORY',
    },
    {
      label: 'CHANGE_ADDRESS_ADD_INFO',
      type: 'text',
      required: false,
      id: 'change-address-addinfo',
      value: addInfo,
      setValue: onAddInfoChangeHandler,
      error: true,
    },
    {
      label: 'CHANGE_ADDRESS_ZIPCODE',
      type: 'text',
      required: true,
      id: 'change-address-zipcode',
      value: zipcode,
      setValue: onZipChangeHandler,
      error: zipcode.length > 0,
      helperText: 'ZIPCODE_MANDATORY',
    },
    {
      label: 'CHANGE_ADDRESS_STATE',
      type: 'text',
      required: true,
      id: 'change-address-state',
      value: state,
      setValue: onStateChangeHandler,
      error: state.length > 0,
      helperText: 'STATE_MANDATORY',
    },
  ];

  const getCountryBasedFormFields = (fieldsConfig, countryFields) => {
    const formFields = [];

    for (const countryField of Object.values(countryFields)) {
      formFields.push(
        fieldsConfig.find((fieldConfig) => {
          return fieldConfig.label == countryField;
        })
      );
    }
    return formFields;
  };

  const countryFormFields = getCountryBasedFormFields(
    formFields,
    countrySpecificConfig[country]?.fields
  );

  const validate = () => {
    if (country === UK_COUNTRY_CODE || country === GERMANY_COUNTRY_CODE) {
      return (
        street.length > 0 &&
        city.length > 0 &&
        zipcode.length === countrySpecificConfig[country]?.zip?.maxLength &&
        house.length > 0
      );
    } else
      return (
        street.length > 0 &&
        city.length > 0 &&
        state.length > 0 &&
        zipcode.length === countrySpecificConfig[country]?.zip?.maxLength
      );
  };
  React.useEffect(() => {
    if (validate()) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [street, city, zipcode, state, house]);

  return (
    <div className={'ServiceRequestChangePhoneWrapper'}>
      <div className={'ServiceRequestCard'}>
        <div className="serviceRequestHeader">
          <div className={'title'}>{t('CHANGE_ADDRESS')}</div>
        </div>
        <div className={'subTitle'}>{t('CHANGE_ADDRESS_SUBTITLE')}</div>
      </div>
      <Box pl={4} pr={4} pb={4}>
        <form onSubmit={addressSubmitHandler}>
          <Card className="cardCustom">
            <CardContent className="ChangeAddressCard">
              {countryFormFields.map((i, index) => (
                <InputWidget
                  key={i.id}
                  required={i.required}
                  type={i.type}
                  id={i.id}
                  label={t(i.label)}
                  value={i.value}
                  setValue={i.setValue}
                  customError={true}
                  error={i.error}
                  helperText={t(i.helperText)}
                />
              ))}
              <div>
                <SelectWidget
                  id="change-address-country"
                  label={t('CHANGE_ADDRESS_COUNTRY')}
                  changeHandler={setSelectedCountry}
                  data={dropDownItem}
                  defaultValue={country}
                />
              </div>
            </CardContent>
          </Card>
          {addressButtonControls()}
        </form>
      </Box>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    userDetails: state.appStates.userDetailsInfo,
  };
};

export default connect(mapStateToProps)(ServiceRequestChangeAddress);
